// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Monday`
};

const el_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Δευτέρα`
};

const ru_monday = /** @type {(inputs: {}) => string} */ () => {
	return `Понедельник`
};

const he_monday = /** @type {(inputs: {}) => string} */ () => {
	return `יום שני`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const monday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.monday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("monday", locale)
	if (locale === "en") return en_monday(inputs)
	if (locale === "el") return el_monday(inputs)
	if (locale === "ru") return ru_monday(inputs)
	if (locale === "he") return he_monday(inputs)
	return "monday"
};